export default __webpack_public_path__ + "static/media/no-results_129x114.558f4add.svg";